import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import { StripedDataTableWrapper } from '../common.StyledComponents';
import {
    ActionsSkeletonRow,
    COLUMN_WIDTH_PERCENT,
    getLabelWidthPercent,
    toWidth,
} from './TemplateManager.StyledComponents';
import { BaseTemplate, TemplateExtraColumn } from './TemplateManager.types';

const SKELETON_ROW_COUNT = 5;
// PrimeReact's Skeleton defaults to a 1rem bar, but design-system's html{font-size:50%} halves that — an explicit px height keeps rows the same size as the real table's.
const SKELETON_BAR_HEIGHT = '16px';

const SKELETON_ROWS = Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => ({
    id: `skeleton-${index}`,
}));

interface TemplateTableSkeletonProps<T extends BaseTemplate> {
    extraColumns?: TemplateExtraColumn<T>[];
}

export const TemplateTableSkeleton = <T extends BaseTemplate>({
    extraColumns = [],
}: TemplateTableSkeletonProps<T>) => (
    <StripedDataTableWrapper>
        <DataTable
            value={SKELETON_ROWS}
            dataKey="id"
            stripedRows
            data-testid="template-table-skeleton"
        >
            <Column
                header="Label"
                style={{
                    width: toWidth(
                        getLabelWidthPercent(extraColumns.map((column) => column.widthPercent)),
                    ),
                    height: '60px',
                }}
                body={() => <Skeleton width="90%" height={SKELETON_BAR_HEIGHT} />}
            />
            {extraColumns.map((column) => (
                <Column
                    key={column.header}
                    header={column.header}
                    style={{ width: toWidth(column.widthPercent), height: '60px' }}
                    body={() => <Skeleton width="70%" height={SKELETON_BAR_HEIGHT} />}
                />
            ))}
            <Column
                header="Status"
                style={{ width: toWidth(COLUMN_WIDTH_PERCENT.status), height: '60px' }}
                body={() => <Skeleton width="60%" height={SKELETON_BAR_HEIGHT} />}
            />
            <Column
                header=""
                style={{ width: toWidth(COLUMN_WIDTH_PERCENT.actions), height: '60px' }}
                body={() => (
                    <ActionsSkeletonRow>
                        <Skeleton width="48px" height={SKELETON_BAR_HEIGHT} />
                        <Skeleton width="48px" height={SKELETON_BAR_HEIGHT} />
                    </ActionsSkeletonRow>
                )}
            />
        </DataTable>
    </StripedDataTableWrapper>
);
